"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putCurrentUserProfilePicture = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
exports.putCurrentUserProfilePicture = (0, sonar_http_1.createPutEndpoint)('/api/v3/core/users/profile-picture', {
    requestTransform: (request) => ({
        fileOptions: {
            file: request.file,
            formName: 'profilePicture'
        }
    })
});
//# sourceMappingURL=putCurrentUserProfilePicture.js.map